module.exports = __webpack_public_path__ + "static/media/walk.d97b1b62.svg";